import { IAddHouseholdMemberRequest, IStatus } from '@/shared/interfaces';
import { fetchIStatus } from '@/shared/fetchIStatus';

export const addAdolescentMember = async (
    newMember: IAddHouseholdMemberRequest,
): Promise<IStatus<string>> => {
    return await fetchIStatus(
        '/api/patients/adolescent-household-member',
        'post',
        newMember,
    );
};
